import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";

const STATUS_STYLES = {
  pending_payment: "bg-[#FFF3EA] text-[#B44618]",
  paid: "bg-[#EAF3EE] text-[#275F36]",
  shipped: "bg-[#E8EEF7] text-[#13294B]",
  delivered: "bg-[#275F36] text-white",
  cancelled: "bg-[#F2EFEB] text-[#718096]",
};

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) { navigate("/auth"); return; }
    api.get("/orders").then((r) => setOrders(r.data));
  }, [user, loading, navigate]);

  return (
    <div className="max-w-5xl mx-auto px-6 py-12">
      <h1 className="text-4xl mb-8">My orders</h1>
      {orders.length === 0 ? (
        <div className="text-[#718096]">No orders yet.</div>
      ) : (
        <div className="space-y-4">
          {orders.map((o) => (
            <div key={o.id} className="card-flat p-6" data-testid={`order-${o.id}`}>
              <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
                <div>
                  <div className="label-caps">Order #{o.id.slice(0, 8)}</div>
                  <div className="text-xs text-[#718096] mt-1">{new Date(o.created_at).toLocaleString('en-IN')}</div>
                </div>
                <div className="flex items-center gap-3">
                  <span className={`px-3 py-1 rounded-full text-xs font-bold uppercase ${STATUS_STYLES[o.status] || ''}`}>{o.status.replace('_', ' ')}</span>
                  <div className="text-lg font-bold">₹{o.total.toLocaleString('en-IN')}</div>
                </div>
              </div>
              <div className="space-y-2">
                {o.items.map((it, i) => (
                  <div key={`${o.id}-${it.product_id}-${i}`} className="flex items-center gap-3 text-sm">
                    {it.image && <img src={it.image} alt="" className="w-10 h-10 rounded object-cover" />}
                    <div className="flex-1">{it.title}</div>
                    <div className="text-[#718096]">× {it.quantity}</div>
                    <div className="w-20 text-right font-semibold">₹{(it.price * it.quantity).toLocaleString('en-IN')}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
